import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { motion } from "framer-motion";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { lenisRef } from "@/lib/scroll";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { FioAdvantage } from "@/components/landing/FioAdvantage";
import { Beliefs } from "@/components/landing/Beliefs";
import { Trims } from "@/components/landing/Trims";
import { Delivery } from "@/components/landing/Delivery";
import { SpotSteps } from "@/components/landing/SpotSteps";
import { SpotDeals } from "@/components/landing/SpotDeals";
import { Pricing } from "@/components/landing/Pricing";
import { LeadForm } from "@/components/landing/LeadForm";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";

const Landing = () => (
    <div className="App bg-[#050505] text-white">
        <Header />
        <main>
            <motion.div
                data-testid="members-save-banner"
                initial={{ opacity: 0, y: -12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 1.5, ease: [0.22, 1, 0.36, 1] }}
                className="mt-[67px] border-b border-white/10 bg-[#2563EB] py-3 text-center"
            >
                <p className="px-6 font-display text-xs font-bold uppercase tracking-[0.3em] text-white sm:text-sm">
                    Our members save time, money, and peace of mind
                </p>
            </motion.div>
            <Hero />
            <Marquee />
            <Manifesto />
            <FioAdvantage />
            <Beliefs />
            <Trims />
            <Delivery />
            <SpotSteps />
            <SpotDeals />
            <Pricing />
            <LeadForm />
            <Faq />
        </main>
        <Footer />
    </div>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            lenisRef.current = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/payment/success" element={<PaymentResult variant="success" />} />
                <Route path="/payment/cancel" element={<PaymentResult variant="cancel" />} />
            </Routes>
            <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
    );
}

export default App;
